import type { LeafletGeolocationApiModel } from '@/types/GeolocationModel'

export interface LocationGroup {
  id: string
  storeId: string
  storeName?: string
  name: string
  geolocations: LeafletGeolocationApiModel[]
  createdAt: string
  createdBy: string
}

export interface LocationGroupDraft {
  name: string
  geolocations: LeafletGeolocationApiModel[]
}

export type LocationGroupValidationErrors = { name?: 'required'; geolocations?: 'required' }

export function validateLocationGroupDraft(draft: LocationGroupDraft): LocationGroupValidationErrors {
  return {
    ...(!draft.name.trim() ? { name: 'required' as const } : {}),
    ...(!draft.geolocations.length ? { geolocations: 'required' as const } : {})
  }
}

export function normalizeLocationGroupDraft(draft: LocationGroupDraft): LocationGroupDraft {
  return { ...draft, name: draft.name.trim() }
}
